import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import {RESULTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import ValidationIcon from 'results/validation/ValidationIcon';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Modal from 'ui-library/modals/Modal';
import {readableTime} from 'util/DateUtil';

import {
  AssayValidationChange,
  AssayValidationHistory,
  WritableAssayValidationStatus,
} from './ValidationConstants';

const VALID = WritableAssayValidationStatus.VALID;
const INVALID = WritableAssayValidationStatus.INVALID;

const statusTexts = {
  [VALID]: {
    title: 'Valid',
    word: 'valid',
  },
  [INVALID]: {
    title: 'Invalid',
    word: 'invalid',
  },
};

interface ValidationChangeProps {
  assayValidationChange: AssayValidationChange;
}
function ValidationChange({assayValidationChange}: ValidationChangeProps): JSX.Element {
  const status = assayValidationChange.status;
  const comment = assayValidationChange.comment;
  return (
    <div className="validationComment u-small-spacing-bottom">
      <ValidationIcon className="validationComment-icon" status={status} />
      <div>
        <div
          className="u-bold-font-weight"
          {...getTestProps({
            component: 'ValidationHistoryModal',
            element: 'status',
          })}
        >
          {statusTexts[status].title}
        </div>
        {comment && comment.trim().length > 0 && (
          <div className="validationComment-text">{comment.trim()}</div>
        )}
        <div className="u-faded u-small-text">
          {assayValidationChange.creator.name} {'\u00B7'} {readableTime(assayValidationChange.createdAt)}
        </div>
      </div>
    </div>
  );
}
ValidationChange.displayName = 'ValidationChange';

interface ValidationHistoryModalProps {
  onRequestClose: () => void;
  history: AssayValidationHistory;
}
export class ValidationHistoryModal extends React.Component<ValidationHistoryModalProps> {
  override componentDidMount(): void {
    analytics.deprecatedTrackEvent(RESULTS_ANALYTICS_ACTIONS.OPENED_VALIDATION_HISTORY_MODAL);
  }

  override render(): JSX.Element {
    const {onRequestClose, history} = this.props;
    const historyReversed = [...history].reverse();
    const modalContent =
      historyReversed.length === 0 ? (
        <div className="u-faded">There are no prior changes.</div>
      ) : (
        historyReversed.map((validationChange, i) => (
          <ValidationChange key={i} assayValidationChange={validationChange} />
        ))
      );
    return (
      <Modal
        title="Validation Changes"
        medium={true}
        onRequestClose={onRequestClose}
        buttons={[
          {
            text: 'Close',
            cancel: true,
          },
        ]}
      >
        <Row>
          <Col md={12}>{modalContent}</Col>
        </Row>
      </Modal>
    );
  }
}
